"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../services");
var getIdentifierFromAuthToken = function () {
    var _a, _b;
    var cvLimitedAccessToken = services_1.Cookies.get('CVLimitedAccessToken');
    return cvLimitedAccessToken
        ? (_b = (_a = JSON.parse(cvLimitedAccessToken)) === null || _a === void 0 ? void 0 : _a.user) !== null && _b !== void 0 ? _b : ''
        : '';
};
exports.default = getIdentifierFromAuthToken;
